import React, { MouseEvent } from 'react';
import { RocheButton as RocheButtonType } from '../../types/global';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';
import { NavigationService } from '../../services/navigation';
import { Link } from '../../services/navigation/types';
import { RocheUIButton } from '@repo/roche-ui';
import { createRocheButtonTrackingObject, handleRocheButtonOnClick } from '../../helpers/roche-button-tracking';

type RocheButtonProps = BlokToComponentProps<
  RocheButtonType & {
    right_icon?: string;
    left_icon?: string;
    href: Link;
  }
>;

type InternalRocheUIButtonProps = { hasMarginTop?: boolean };

export const RocheButton = ({
  blok: { appearance, href, right_icon: rightIcon, left_icon: leftIcon, target, text },
  slot,
  hasMarginTop,
}: RocheButtonProps & InternalRocheUIButtonProps): JSX.Element => {
  const buttonHref = NavigationService.getParsedNavigationLink(href);

  return (
    <RocheUIButton
      hasMarginTop={hasMarginTop}
      text={text}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      target={target}
      appearance={appearance}
      href={buttonHref}
      onClick={(clickEvent: MouseEvent) => {
        const trackingData = createRocheButtonTrackingObject(text, buttonHref);
        handleRocheButtonOnClick(clickEvent, trackingData);
      }}
      slot={slot}
    />
  );
};
